import React from "react";

import Notifications from "../navbar/Notication/Notifications";
import UserDropdown from "../navbar/UserDropdown";

import { isSubDomain } from "@/lib/utils";

type SidebarFooterProps = {
  isInteracting: boolean;
  setInteracting: React.Dispatch<React.SetStateAction<boolean>>;
};

const SidebarFooter = ({
  isInteracting,
  setInteracting,
}: SidebarFooterProps): React.JSX.Element => {
  return (
    <div className='relative p-2'>
      <div className='flex items-center justify-between w-full p-2 border rounded-md'>
        <UserDropdown
          side={"right"}
          isInteracting={isInteracting}
          setInteracting={setInteracting}
        />

        {isSubDomain && <Notifications />}
        {/* <div className='absolute transition-transform ease-in-out cursor-pointer right-3 top-4 active:text-primary hover:text-primary hover:rotate-90 '>
      <X size={18} onClick={() => setShowUser(!showUser)} />
    </div> */}
      </div>
    </div>
  );
};

export default SidebarFooter;
